var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg161(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "171") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-night",
    transform: "translate(-2274.000000, -6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: 171,
    transform: "translate(2276.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48311688,-1.42108547e-14 C8.93746523,-1.42108547e-14 11.0732337,1.36378252 12.1739756,3.37490093 C10.3450064,4.91579088 9.12160498,7.15142258 8.90969766,9.67480519 L8.90969766,9.67480519 L8.37848104,9.67480519 C6.33728496,9.67480519 4.52756557,10.6631654 3.40140183,12.1872963 C1.3755217,11.0915727 1.56319402e-13,8.94800587 1.56319402e-13,6.48311688 C1.56319402e-13,2.9025413 2.9025413,-1.42108547e-14 6.48311688,-1.42108547e-14 Z",
    id: "Combined-Shape",
    fill: "#BEE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7615584,21.2945455 C28.7615879,21.6167504 28.557227,21.8938298 28.2677019,21.998314 L28.1813896,22.021987 L28.1063665,22.0082101 C27.9302466,21.9626329 27.7834634,21.8649287 27.6818786,21.7344769 L28.3498939,20.6255736 C28.5940792,20.7493814 28.7615584,21.0024034 28.7615584,21.2945455 Z M25.3697069,7.61507119 L25.464586,7.86920727 L25.8790068,9.04095584 L27.1068094,8.84845714 C27.4088229,8.80108052 27.7161226,8.77714286 28.027013,8.77714286 C31.2770494,8.77714286 33.9116883,11.4117818 33.9116883,14.6618182 C33.9116883,17.7563685 31.5176284,20.3069466 28.4093078,20.5284906 L30.6790867,16.7524675 L25.0525293,16.7524675 L27.9449969,10.2693506 L17.814659,10.2693506 L14.9213896,20.545987 L8.37848104,20.5464935 C5.78892468,20.5464935 3.69038961,18.4481579 3.69038961,15.8587013 C3.69038961,13.341368 5.67386436,11.287873 8.1638479,11.1757323 L8.37848104,11.1709091 L10.2854151,11.1709091 L10.4006151,9.79997922 C10.7367397,5.79720312 14.0960914,2.69298701 18.1398608,2.69298701 C21.3656547,2.69298701 24.2140615,4.67712169 25.3697069,7.61507119 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FED100",
    points: "18.9506494 11.7693506 16.0581818 22.0425974 21.0451948 22.0425974 18.2524675 34.5101299 28.027013 18.2524675 22.7407792 18.2524675 25.6332468 11.7693506"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg161);
export default __webpack_public_path__ + "static/media/161.40b0256300562377f3c8a26123d48e24.svg";
export { ForwardRef as ReactComponent };